// extracted by mini-css-extract-plugin
var _1 = "TeacherMenu__arrow--thHTs";
var _2 = "TeacherMenu__button--nBjSb fontSize__teacherButton--gEx30";
var _3 = "TeacherMenu__buttonList--xUHCh";
var _4 = "TeacherMenu__circle--pgX0H TeacherMenu__circlePosition--oq834 TeacherMenu__shadow--hluGw";
var _5 = "TeacherMenu__circlePosition--oq834";
var _6 = "TeacherMenu__closed--ieweL";
var _7 = "TeacherMenu__connector--ZtQmt";
var _8 = "TeacherMenu__connectorShadow--GPEHc TeacherMenu__shadow--hluGw";
var _9 = "TeacherMenu__hover--GHfNn TeacherMenu__circlePosition--oq834";
var _a = "TeacherMenu__icon--Eccfo";
var _b = "TeacherMenu__main--y72GH CoreGeneral__roboto--UlmjE";
var _c = "TeacherMenu__menu--cMC2X TeacherMenu__shadow--hluGw";
var _d = "TeacherMenu__open--GIkwj";
var _e = "TeacherMenu__shadow--hluGw";
export { _1 as "arrow", _2 as "button", _3 as "buttonList", _4 as "circle", _5 as "circlePosition", _6 as "closed", _7 as "connector", _8 as "connectorShadow", _9 as "hover", _a as "icon", _b as "main", _c as "menu", _d as "open", _e as "shadow" }
